import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const [dimensions, setDimensions] = useState({
    height: window.innerHeight,
    width: window.innerWidth,
  });
  const [pathName, setPathName] = useState(location.pathname);
  useEffect(() => {
    setPathName(location.pathname);
    function handleResize() {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth,
      });
    }
    window.addEventListener('resize', handleResize);
    return (_) => {
      window.removeEventListener('resize', handleResize);
    };
  }, [location]);

  const titles = [
    { width: 0, to: '/conditions', text: 'Conditions' },
    { width: 930, to: '/Actions', text: 'Actions' },
    { width: 1030, to: '/Rules', text: 'Rules' },
    { width: 1290, to: '/logs', text: 'Logs' },
  ];
  return user?._id ? (
    <header id='header'>
      <div className='container d-flex align-items-center'>
        <h1 className='logo mr-auto d-flex align-items-center'>
          <img src='/assets/img/logo.png' alt='mine-marketing.com' className='img-fluid mr-1' />
          <Link to='/'>
            Quantum<span className='text-secondary'>Rules</span>
          </Link>
        </h1>

        <div className='row d-flex justify-content-left mr-auto'>
          {titles.map((title, i) => {
            if (dimensions.width < title.width) return null;
            if (i === 0)
              return (
                <span
                  key={`headerTitle${i}`}
                  className={`header-box btn btn-${title.to === pathName ? '' : 'outline-'}dark border-0`}
                >
                  <Link to={title.to}>{title.text}</Link>
                </span>
              );
            return (
              <span
                key={`headerTitle${i}`}
                className={`header-box btn btn-${title.to === pathName ? '' : 'outline-'}dark ms-4 border-0`}
              >
                <Link to={title.to}>{title.text}</Link>
              </span>
            );
          })}
        </div>

        <nav className='nav-menu d-none d-lg-block'>
          <Link
            to={'/profile'}
            style={{ fontSize: '1.5rem' }}
            className='btn btn-lg btn-outline-light border-0'
            title='Account'
          >
            <i className='fa-regular fa-user'></i>
          </Link>
        </nav>
      </div>
    </header>
  ) : null;
};

export default Header;
